import { getEnvDefault, NODE_ENV } from '@main/core-ui';
import { ImmutableUrl } from '@main/immutable-url';

/**
 * The url of the backend server
 */
export const BACKEND_URL = new ImmutableUrl(
  getEnvDefault('BACKEND_URL', 'https://api.us.transcend.io', 'https://yo.com:4001'),
);

/**
 * The url of the Transcend splash page. This is where the Transcend logo redirects to
 */
export const TRANSCEND_HOMEPAGE_URI = new ImmutableUrl(
  getEnvDefault(
    'TRANSCEND_HOMEPAGE_URI',
    '___TRANSCEND_HOMEPAGE_URI___',
    'https://transcend.io',
  ),
);

/**
 * The name of the datadog service
 */
export const DATADOG_SERVICE = getEnvDefault(
  'DATADOG_SERVICE',
  '___DATADOG_SERVICE___',
  'privacy-center',
);

/**
 * The name of the datadog container when logging
 */
export const DATADOG_CONTAINER_NAME = getEnvDefault(
  'DATADOG_CONTAINER_NAME',
  '___DATADOG_CONTAINER_NAME___',
  'privacy-center',
);

/**
 * gets the github user for use in building the default prefix
 */
export const GITHUB_USER = getEnvDefault(
  'GITHUB_USER',
  '___GITHUB_USER___',
  '',
);

/**
 * Get the static precompiled privacy center asset prefix (github username). Should
 * be undefined/empty in PROD, and be auto-generated in local dev
 */
export const PRIVACY_CENTER_STATIC_PREFIX = getEnvDefault(
  'PREPEND_KEY',
  '___PREPEND_KEY___',
  NODE_ENV !== 'production' ? `${GITHUB_USER || 'unknown'}/${NODE_ENV}` : '',
);
